<template>
  <div>
    <a-tabs v-model="queryForm.date" size="small" @change="getdata()">
      <a-tab-pane v-for="item in dates" :key="item" :tab="item"></a-tab-pane>
      <a-button slot="tabBarExtraContent" type="primary" @click="showdownloadtask">
        导出派车任务
      </a-button>
    </a-tabs>
    <v-card tile>
      <a-input-search placeholder="输入车牌号，回车自动定位到结果行并高亮" enter-button @input="onInput" @search="onSearch" />
      <div class="d-flex justify-space-between pa-1">
        <a-space>
          <v-btn color="error" tile small :disabled="selectedRowKeys.length === 0" @click="bulkremove">批量删除</v-btn>
          <v-btn color="primary" tile small @click="getdata()">刷新</v-btn>
          <a-input-search v-model="quickText" required placeholder="郑州-焦作	晋B09134D	豫A242A挂	16.5	海峰	13592608988	1400"
            enter-button="识别并添加" @search="quickAdd" style="width:750px;" />
        </a-space>
        <a-space>
          <v-btn color="primary" tile small @click="showresult()">调车计划</v-btn>
        </a-space>
      </div>
      <a-table size="small" bordered :columns="headers" :data-source="list" :pagination="false" tableLayout="fixed"
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }" row-key="_id" :row-selection="{
          selectedRowKeys,
          onChange: (keys) => selectedRowKeys = keys,
          getCheckboxProps: (record) => {
            return {
              props: {
                disabled: record._type === 'header' || record._type === 'vehicle',
              }
            }
          }
        }" :customRow="(record) => {
          let opts = {
            // className: record.isNew ? 'new_created' : (record.markColor || ''),
            className: record.markColor || '',
          };
          if (record._type === 'item' && matchids.includes(record._id)) {
            opts.className = 'highlight';
          }
          if (record._type === 'vehicle') {
            opts.className = 'vehicle';
          }
          return opts;
        }" ref="tableRef" @scroll="handleScroll">
        <!--排序-->
        <template slot="A" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <a-input v-if="record.index_editable" v-model="record.index" type="number" :min="1" placeholder="序号"
              style="width:100%" @blur="() => update(record, 'index', record.index, 'index_editable')" />
            <template v-else>
              <a-space>
                <a-icon v-if="username === 'root'" type="delete" class="error--text"
                  @click="remove([record._id])"></a-icon>
                <p @click="edit(record, 'index_editable')">{{ record.index || '--' }}</p>
              </a-space>
            </template>
          </template>
        </template>
        <!--始发地-->
        <template slot="C" slot-scope="text, record">
          <span v-if="record._type === 'header'" class="error--text font-weight-bold">{{ record.header }}
            <v-btn icon small @click="showadd(record)">
              <v-icon class="success--text">mdi-plus-circle</v-icon>
            </v-btn>
          </span>
          <template v-else-if="record._type === 'item'">
            {{ record.departure }}
          </template>
        </template>
        <!--卸货地-->
        <template slot="D" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            {{ record.destination }}
          </template>
        </template>
        <!--颜色标记-->
        <template slot="E" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <a-dropdown>
              <div class="ant-dropdown-link" @click="e => e.preventDefault()">
                <span>标记</span>
                <a-icon type="down" />
              </div>
              <a-menu slot="overlay" @click="(e) => update(record, 'markColor', e.key)">
                <template v-for="item in colors">
                  <a-menu-item v-if="record.markColor !== item.value" :key="item.value" :class="item.value"
                    style="height:20px;padding:0;">
                    <p href="javascript:;" style="width:100%;text-align:center;font-size:10px;">{{ item.label }}</p>
                  </a-menu-item>
                </template>
              </a-menu>
            </a-dropdown>
          </template>
        </template>
        <!--车牌号-->
        <template slot="F" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <a-auto-complete v-if="record.vehicle_editable" v-model="record.vehicle_number" style="width:100%;"
              placeholder="车头" @select="(v) => handleSelect(record, 'vehicle_number', v, 'vehicle_editable')"
              @blur="handleSelect(record, 'vehicle_number', record.vehicle_number, 'vehicle_editable')"
              @search="(v) => handleSearch(record, 'vehicle_number', v)">
              <template slot="dataSource">
                <a-select-option v-for="d in record.vehicle_data" :key="d.value">
                  {{ d.text }}
                </a-select-option>
              </template>
            </a-auto-complete>
            <div v-else style="cursor:pointer;" @click="edit(record, 'vehicle_editable')">
              {{ record.vehicle_number || '--' }}
            </div>
          </template>
          <template v-else-if="record._type === 'vehicle'">
            <a-tooltip>
              <template slot="title">
                <div>
                  <p>最近位置：{{ record.address }}</p>
                  <p>更新时间：{{ record.locationTime }}</p>
                </div>
              </template>
              {{ record.vehicle_number || '--' }}
            </a-tooltip>
            <p v-if="record.vehicle_number && record.area" :style="{
              'color': areacolors[record.area]
            }">{{ record.area }}</p>
          </template>
          <span v-else-if="record._type === 'header' && record.vcount >= 0" class="error--text font-weight-bold">
            {{ record.vcount }}头
          </span>
        </template>
        <!--挂厢号-->
        <template slot="G" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <a-auto-complete v-if="record.gvehicle_editable" v-model="record.vehicle_gnumber" style="width:100%;"
              placeholder="挂箱" @select="(v) => handleSelect(record, 'vehicle_gnumber', v, 'gvehicle_editable')"
              @blur="handleSelect(record, 'vehicle_gnumber', record.vehicle_gnumber, 'gvehicle_editable')"
              @search="(v) => handleSearch(record, 'vehicle_gnumber', v)">
              <template slot="dataSource">
                <a-select-option v-for="d in record.gvehicle_data" :key="d.value">
                  {{ d.text }}
                </a-select-option>
              </template>
            </a-auto-complete>
            <div v-else style="cursor:pointer;" @click="edit(record, 'gvehicle_editable')">
              {{ record.vehicle_gnumber || '--' }}
            </div>
          </template>
          <template v-else-if="record._type === 'vehicle'">
            <a-tooltip>
              <template slot="title">
                <div>
                  <p>最近位置：{{ record.address }}</p>
                  <p>更新时间：{{ record.locationTime }}</p>
                </div>
              </template>
              {{ record.vehicle_gnumber || '--' }}
            </a-tooltip>
            <p v-if="record.vehicle_gnumber && record.area" :style="{
              'color': areacolors[record.area]
            }">{{ record.area }}</p>
          </template>
          <span v-else-if="record._type === 'header' && record.vcount >= 0" class="error--text font-weight-bold">
            {{ record.gcount }}挂
          </span>
        </template>
        <!--车型-->
        <template slot="H" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            {{ record.vehicle_type }}
          </template>
          <div v-else-if="record._type === 'vehicle'">
            {{ record.vehicle_type || '--' }}
          </div>
        </template>
        <!--司机-->
        <template slot="I" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <a-auto-complete v-if="record.driver_editable" v-model="record.driver" style="width:100%;" placeholder="司机"
              @select="(v) => handleSelect(record, 'driver', v, 'driver_editable')"
              @blur="handleSelect(record, 'driver', record.driver, 'driver_editable')"
              @search="(v) => handleSearch(record, 'driver', v)">
              <template slot="dataSource">
                <a-select-option v-for="d in record.driver_data" :key="d.value">
                  {{ d.text }}
                </a-select-option>
              </template>
            </a-auto-complete>
            <div v-else style="cursor:pointer;" @click="edit(record, 'driver_editable')">
              {{ record.driver || '--' }}
            </div>
          </template>
          <div v-else-if="record._type === 'vehicle'">
            {{ record.driver || '--' }}
          </div>
        </template>
        <!--运价-->
        <template slot="J" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <a-input v-if="record.price_editable" v-model="record.price" placeholder="运价" style="width:100%"
              @blur="() => update(record, 'price', record.price, 'price_editable')" />
            <div v-else style="cursor:pointer;" @click="edit(record, 'price_editable')">
              {{ record.price || '--' }}
            </div>
          </template>
        </template>
        <!--蜂羽-->
        <template slot="K" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <a-dropdown>
              <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                <template v-if="record.platform_state">
                  <template v-for="item in task_states">
                    <span v-if="record.platform_state === item.value" :key="item.value" :style="{
                      'color': $utils.textToBgColor(item.label)
                    }">{{ item.label }}</span>
                  </template>
                </template>
                <template v-else>--</template>
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay" @click="(e) => update(record, 'platform_state', e.key)">
                <template v-for="item in task_states">
                  <a-menu-item v-if="record.platform_state !== item.value" :key="item.value">
                    <a href="javascript:;" :style="{
                      'color': $utils.textToBgColor(item.label)
                    }">{{ item.label }}</a>
                  </a-menu-item>
                </template>
              </a-menu>
            </a-dropdown>
          </template>
        </template>
        <!--任务名称-->
        <template slot="L" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <a-input v-if="record.name_editable" v-model="record.name" placeholder="派车单号" style="width:100%"
              @blur="() => update(record, 'name', record.name, 'name_editable')" />
            <div v-else style="cursor:pointer;" @click="edit(record, 'name_editable')">
              {{ record.name || '--' }}
            </div>
          </template>
        </template>
        <!--车辆状态-->
        <template slot="M" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <a-input v-if="record.vehiclestate_editable" v-model="record.vehiclestate" placeholder="车辆状态"
              style="width:100%"
              @blur="() => update(record, 'vehiclestate', record.vehiclestate, 'vehiclestate_editable')" />
            <div v-else style="cursor:pointer;" @click="edit(record, 'vehiclestate_editable')">
              {{ record.vehiclestate || '--' }}
            </div>
          </template>
          <a-tooltip v-else-if="record._type === 'vehicle'">
            <template slot="title">
              <div>
                <p>最近位置：{{ record.address }}</p>
                <p>更新时间：{{ record.locationTime }}</p>
              </div>
            </template>
            <p>{{ record.vehiclestate || '--' }}</p>
            <p v-if="record.vehiclestatetime" class="error--text">{{ record.vehiclestatetime }}</p>
          </a-tooltip>
        </template>
        <!--中邮任务-->
        <template slot="N" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <a-dropdown>
              <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                <template v-if="record.task_state">
                  <template v-for="item in task_states">
                    <span v-if="record.task_state === item.value" :key="item.value" :style="{
                      'color': $utils.textToBgColor(item.label)
                    }">{{ item.label }}</span>
                  </template>
                </template>
                <template v-else>--</template>
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay" @click="(e) => update(record, 'task_state', e.key)">
                <template v-for="item in task_states">
                  <a-menu-item v-if="record.task_state !== item.value" :key="item.value">
                    <a href="javascript:;" :style="{
                      'color': $utils.textToBgColor(item.label)
                    }">{{ item.label }}</a>
                  </a-menu-item>
                </template>
              </a-menu>
            </a-dropdown>
          </template>
        </template>
        <!--派车单号-->
        <template slot="O" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <a-input v-if="record.dispatch_no_editable" v-model="record.dispatch_no" placeholder="派车单号"
              style="width:100%"
              @blur="() => update(record, 'dispatch_no', record.dispatch_no, 'dispatch_no_editable')" />
            <div v-else style="cursor:pointer;" @click="edit(record, 'dispatch_no_editable')">
              {{ record.dispatch_no || '--' }}
            </div>
          </template>
        </template>
        <!--GPS状态-->
        <template slot="P" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <template v-if="record.gps_state === 0">
              <a-input v-if="record.gps_no_editable" v-model="record.gps_no" placeholder="GPS序列号" style="width:100%"
                @blur="() => update(record, 'gps_no', record.gps_no, 'gps_no_editable')" />
              <div v-else style="cursor:pointer;" @click="edit(record, 'dispatch_no_editable')">
                {{ record.gps_no || '--' }}
              </div>
            </template>
            <a-dropdown v-else>
              <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                <template v-if="record.gps_state">
                  <template v-for="item in gps_states">
                    <span v-if="record.gps_state === item.value" :key="item.value" :style="{
                      'color': $utils.textToBgColor(item.label)
                    }">{{ item.label }}</span>
                  </template>
                </template>
                <template v-else>--</template>
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay" @click="(e) => update(record, 'gps_state', e.key)">
                <template v-for="item in gps_states">
                  <a-menu-item v-if="record.gps_state !== item.value" :key="item.value">
                    <a href="javascript:;" :style="{
                      'color': $utils.textToBgColor(item.label)
                    }">{{ item.label }}</a>
                  </a-menu-item>
                </template>
              </a-menu>
            </a-dropdown>
          </template>
        </template>
        <!--调车人-->
        <template slot="Q" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <a-input v-if="record.dispatch_name_editable" v-model="record.dispatch_name" placeholder="调车人"
              style="width:100%"
              @blur="() => update(record, 'dispatch_name', record.dispatch_name, 'dispatch_name_editable')" />
            <div v-else style="cursor:pointer;" @click="edit(record, 'dispatch_name_editable')">
              {{ record.dispatch_name || '--' }}
            </div>
          </template>
        </template>
        <!--蜂羽派车单号-->
        <!-- <template slot="R" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <a-input v-if="record.platform_no_editable" v-model="record.platform_no" placeholder="平台单号"
              style="width:100%" @blur="() => update(record, 'platform_no', record.platform_no, 'platform_no')" />
            <div v-else style="cursor:pointer;" @click="edit(record, 'platform_no_editable')">
              {{ record.platform_no || '--' }}
            </div>
          </template>
        </template> -->
        <!--套牌号-->
        <template slot="S" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <a-input v-model="record.vehicle_onumber" placeholder="套牌号" style="width:100%"
              @blur="() => update(record, 'vehicle_onumber', record.vehicle_onumber)" />
          </template>
        </template>
        <!--备注-->
        <template slot="T" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <a-input v-model="record.remark" placeholder="备注" style="width:100%"
              @blur="() => update(record, 'remark', record.remark)" />
          </template>
        </template>
      </a-table>
    </v-card>
    <v-dialog v-model="addmodel" hide-overlay persistent width="600">
      <v-card tile>
        <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
          选择线路
          <v-icon @click="() => addmodel = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-row v-for="(item, index) in addform.list" :key="index">
            <v-col cols="6">
              <v-autocomplete v-model="item.postlineid" :items="postlines" label="线路"
                :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense hide-details>
              </v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-autocomplete v-model="item.vehicle_type" :items="[
                { value: '5吨', text: '5吨' },
                { value: '8吨', text: '8吨' },
                { value: '12吨', text: '12吨' },
                { value: '20吨', text: '20吨' },
                { value: '30吨', text: '30吨' },
              ]" label="车型" :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense hide-details>
              </v-autocomplete>
            </v-col>
            <v-col cols="2">
              <v-btn v-if="index === 0" icon @click="additem">
                <v-icon class="success--text">mdi-plus-circle</v-icon>
              </v-btn>
              <v-btn v-else icon @click="removeitem(index)">
                <v-icon class="error--text">mdi-minus-circle</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" tile @click="add">确定</v-btn>
          <v-btn tile @click="() => addmodel = false">关闭</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DispatchResult ref="dispatchresultRef" />
    <DownloadTask ref="downloadtaskRef" modelTitle="导出派车任务" downloadType="dispatchplanv2" />
  </div>
</template>

<script>
import _ from "underscore";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { mapState } from "vuex";
import DispatchResult from './dispatch/result.vue';
import DownloadTask from '@/components/downloadtask.vue';
let timeout;
let currentValue;
function fetch_data(sources, value, callback) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;
  function filter_data() {
    if (currentValue === value) {
      const result = sources.filter(n => n.label.includes(value));
      const data = [];
      result.forEach(r => {
        data.push({
          value: r.label,
          text: r.label,
        });
      });
      callback(data);
    }
  }
  timeout = setTimeout(filter_data, 300);
}
export default {
  name: "Dispatchplan2",
  data() {
    return {
      locale,
      queryForm: {
        groupid: 2,
        date: this.$moment().format('YYYY-MM-DD'),
      },
      selectedRowKeys: [],
      groups: [],
      dates: [
        this.$moment().add(-3, 'day').format('YYYY-MM-DD'),
        this.$moment().add(-2, 'day').format('YYYY-MM-DD'),
        this.$moment().add(-1, 'day').format('YYYY-MM-DD'),
        this.$moment().add(0, 'day').format('YYYY-MM-DD'),
        this.$moment().add(1, 'day').format('YYYY-MM-DD'),
        this.$moment().add(2, 'day').format('YYYY-MM-DD'),
        this.$moment().add(3, 'day').format('YYYY-MM-DD'),
      ],
      headers: [
        { dataIndex: "A", scopedSlots: { customRender: "A" }, width: 80, align: "center", title: "#", },
        // { dataIndex: "B", scopedSlots: { customRender: "B" }, width: 90, align: "center", title: "预估时间", },
        { dataIndex: "C", scopedSlots: { customRender: "C" }, width: 80, align: "center", title: "始发地", },
        { dataIndex: "D", scopedSlots: { customRender: "D" }, width: 90, align: "center", title: "卸货地", },
        { dataIndex: "E", scopedSlots: { customRender: "E" }, width: 50, align: "center", title: "#", },
        { dataIndex: "F", scopedSlots: { customRender: "F" }, width: 120, align: "center", title: "车牌号*", },
        { dataIndex: "G", scopedSlots: { customRender: "G" }, width: 120, align: "center", title: "挂厢号*", },
        { dataIndex: "H", scopedSlots: { customRender: "H" }, width: 50, align: "center", title: "车型", },
        { dataIndex: "I", scopedSlots: { customRender: "I" }, width: 200, align: "center", title: "司机*", },
        { dataIndex: "J", scopedSlots: { customRender: "J" }, width: 80, align: "center", title: "运价*", },
        { dataIndex: "K", scopedSlots: { customRender: "K" }, width: 80, align: "center", title: "蜂羽", },
        { dataIndex: "L", scopedSlots: { customRender: "L" }, width: 125, align: "center", title: "任务名称", },
        { dataIndex: "M", scopedSlots: { customRender: "M" }, width: 100, align: "center", title: "车辆状态", },
        { dataIndex: "N", scopedSlots: { customRender: "N" }, width: 80, align: "center", title: "中邮任务", },
        { dataIndex: "O", scopedSlots: { customRender: "O" }, width: 120, align: "center", title: "派车单号*", },
        { dataIndex: "P", scopedSlots: { customRender: "P" }, width: 80, align: "center", title: "GPS状态", },
        { dataIndex: "dispatch_price", scopedSlots: { customRender: "dispatch_price" }, width: 100, align: "center", title: "调车参考价", },
        { dataIndex: "Q", scopedSlots: { customRender: "Q" }, width: 100, align: "center", title: "调车人*", },
        // { dataIndex: "R", scopedSlots: { customRender: "R" }, width: 110, align: "center", title: "蜂羽派车单号*", },
        { dataIndex: "S", scopedSlots: { customRender: "S" }, width: 120, align: "center", title: "套牌号", },
        { dataIndex: "T", scopedSlots: { customRender: "T" }, width: 150, align: "center", title: "备注", },
      ],
      list: [],
      height: 600,
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      vehicle_states: [],
      gps_states: [],
      task_states: [],
      gvehicles: [],
      vehicles5: [],
      vehicles8: [],
      vehicles12: [],
      vehicles20: [],
      vehicles30: [],
      drivers: [],
      postlines: [],
      addmodel: false,
      addform: {
        list: [
          { postlineid: "", vehicle_type: "12吨" }
        ]
      },
      matchids: [],
      matchindex: -1,
      colors: [
        { value: '', color: '#FFFFFF', label: '清除' },
        // { value: 'line0', color: '#DDEBF7' },
        // { value: 'line1', color: '#BDD7EE' },
        { value: 'line2', color: '#9DC3E6' },
        // { value: 'line3', color: '#E2EFDA' },
        // { value: 'line4', color: '#C6E0B4' },
        // { value: 'line5', color: '#FFF2CC' },
        { value: 'line6', color: '#FFE699' },
        // { value: 'line7', color: '#FCE4D6' },
        // { value: 'line8', color: '#FCE4EC' },
        // { value: 'line9', color: '#E8DAEF' },
      ],
      quickText: "",
      areacolors: {
        '南信周': '#D84141',
        '商丘开封': '#D8C341',
        '安濮鹤新': '#6CD841',
        '机动车辆': '#41D897',
        '洛焦济三': '#4197D8',
        '漯平许驻': '#6C41D8',
        '豫东豫北': '#D841C3'
      },
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    allvehicles() {
      return [
        ...this.vehicles5,
        ...this.vehicles8,
        ...this.vehicles12,
        ...this.vehicles20,
        ...this.vehicles30,
      ];
    },
  },
  components: { DispatchResult, DownloadTask },
  watch: {},
  mounted() {
    this.height = window.innerHeight - 300;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 300;
    };
    this.list = [];
  },
  activated() {
    this.dates = [
      this.$moment().add(-3, 'day').format('YYYY-MM-DD'),
      this.$moment().add(-2, 'day').format('YYYY-MM-DD'),
      this.$moment().add(-1, 'day').format('YYYY-MM-DD'),
      this.$moment().add(0, 'day').format('YYYY-MM-DD'),
      this.$moment().add(1, 'day').format('YYYY-MM-DD'),
      this.$moment().add(2, 'day').format('YYYY-MM-DD'),
      this.$moment().add(3, 'day').format('YYYY-MM-DD'),
    ];
    this.getdata();
  },
  methods: {
    init(v) {
      this.queryForm.groupid = v;
      this.getdata();
    },
    showresult() {
      this.$refs.dispatchresultRef.init(this.queryForm);
    },
    getdata(payload) {
      if (payload?.hideloading !== true) {
        this.$toast.loading({ message: "" });
      }
      this.selectedRowKeys = [];
      this.$api.doAPI("/dispatchplan/v2/list", this.queryForm).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.groups = res.data.groups;
          this.dates = res.data.dates;
          this.vehicle_states = res.data.vehicle_states;
          this.gps_states = res.data.gps_states;
          this.task_states = res.data.task_states;
          this.vehicles5 = res.data.vehicles5;
          this.vehicles8 = res.data.vehicles8;
          this.vehicles12 = res.data.vehicles12;
          this.vehicles20 = res.data.vehicles20;
          this.vehicles30 = res.data.vehicles30;
          this.gvehicles = res.data.gvehicles;
          this.drivers = res.data.drivers;
          this.makedata(res.data);
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    onInput(e) {
      let value = e.data;
      console.log('onInput', value);
      if (!value) {
        this.matchids = [];
        this.matchindex = -1;
        this.scrollToRow("");
      }
    },
    onSearch(value) {
      console.log('onSearch', value);
      this.matchids = this.list.filter(n => {
        if (value) {
          return (
            (
              n.vehicle_number && n.vehicle_number.includes(value)
            )
            // ||
            // (
            //   n.driver && n.driver.includes(value)
            // )
          )
        }
        return false;
      }).map(n => n._id);
      if (this.matchids.length > 0) {
        this.matchindex++;
        if (this.matchindex > this.matchids.length - 1) {
          this.matchindex = 0;
        }
        this.scrollToRow(this.matchids[this.matchindex]);
      }
      else {
        this.matchindex = -1;
        this.scrollToRow("");
      }
    },
    scrollToRow(_id) {
      const row = this.list.find(n => n._id === _id);
      const tableBody = this.$refs.tableRef.$el.querySelector('.ant-table-body');
      if (row) {
        if (tableBody) {
          const rowElement = tableBody.querySelector(`[data-row-key="${row._id}"]`);
          if (rowElement) {
            const tableBodyScrollTop = rowElement.offsetTop - tableBody.offsetTop;
            tableBody.scrollTop = tableBodyScrollTop;
            return;
          }
        }
      }
      tableBody.scrollTop = 0;
    },
    handleScroll() {
      console.log('handleScroll');
      this.matchindex = -1;
    },
    copy(value) {
      if (!value) return;
      let that = this;
      this.$copyText(value).then(
        function (e) {
          that.$toast.success(`已复制:${value}`);
          console.log(e);
        },
        function (e) {
          console.log(e);
        }
      );
    },
    handleSearch(item, key, value) {
      if (key === 'vehicle_number') {
        let vehicles = this.allvehicles;
        // if (item.vehicle_type === '5吨') vehicles = this.vehicles5;
        // if (item.vehicle_type === '8吨') vehicles = this.vehicles8;
        // if (item.vehicle_type === '12吨') vehicles = this.vehicles12;
        // if (item.vehicle_type === '20吨') vehicles = this.vehicles20;
        // if (item.vehicle_type === '30吨') vehicles = this.vehicles30;
        fetch_data(
          vehicles,
          value,
          data => (item.vehicle_data = data)
        );
      }
      else if (key === 'vehicle_gnumber') {
        fetch_data(
          this.gvehicles,
          value,
          data => (item.gvehicle_data = data)
        );
      }
      else if (key === 'driver') {
        fetch_data(
          this.drivers,
          value,
          data => (item.driver_data = data)
        );
      }
    },
    handleSelect(item, key, value, keyE) {
      console.log('handleSelect', value);
      if (key === 'vehicle_number') {
        item[key] = value;
        let vehicles = this.allvehicles;
        // if (item.vehicle_type === '5吨') vehicles = this.vehicles5;
        // if (item.vehicle_type === '8吨') vehicles = this.vehicles8;
        // if (item.vehicle_type === '12吨') vehicles = this.vehicles12;
        // if (item.vehicle_type === '20吨') vehicles = this.vehicles20;
        // if (item.vehicle_type === '30吨') vehicles = this.vehicles30;
        fetch_data(
          vehicles,
          value,
          data => (item.vehicle_data = data)
        );
      }
      else if (key === 'vehicle_gnumber') {
        item[key] = value;
        fetch_data(
          this.gvehicles,
          value,
          data => (item.gvehicle_data = data)
        );
      }
      else if (key === 'driver') {
        item[key] = value;
        fetch_data(
          this.drivers,
          value,
          data => (item.driver_data = data)
        );
      }
      this.update(item, key, value, keyE);
    },
    edit(item, key) {
      item[key] = true;
    },
    update(item, key, value, keyE) {
      // this.$toast.loading({ message: "" });
      item[keyE] = false;
      this.$api.doAPI("/dispatchplan/v2/update", { _id: item._id, key, value }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata({ hideloading: true });
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    additem() {
      this.addform.list.push(
        { postlineid: "", vehicle_type: "12吨" }
      );
    },
    removeitem(index) {
      this.addform.list.splice(index, 1);
    },
    showadd(item) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchplan/v2/showadd", {
        groupid: this.queryForm.groupid,
        date: this.queryForm.date,
        ...item,
      }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.postlines = res.data.postlines;
          this.addform = {
            groupid: this.queryForm.groupid,
            date: this.queryForm.date,
            ...item,
            list: [
              { postlineid: "", vehicle_type: "12吨" },
            ],
          };
          this.addmodel = true;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    add() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchplan/v2/bulkadd", this.addform).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
          this.addmodel = false;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    quickAdd() {
      if (!this.quickText) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchplan/v2/quickadd", {
        groupid: this.queryForm.groupid,
        date: this.queryForm.date,
        text: this.quickText,
      }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.quickText = "";
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    bulkremove() {
      if (this.selectedRowKeys.length === 0) return;
      this.remove(this.selectedRowKeys);
    },
    remove(ids) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchplan/v2/remove", { ids }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    ispassday() {
      return new Date(`${this.queryForm.date} 00:00:00.000+08:00`).getTime() < this.$dayjs().startOf('day').valueOf();
    },
    makedata({ list, groups, vehiclesh }) {
      let group = groups.find((g) => g.value === this.queryForm.groupid);
      let headers = group.headers;
      let result = [];
      let update_index = false;
      for (let header of headers) {
        let vehicles = vehiclesh[header];
        let items = list.filter(n => n.header === header);
        let vcount;
        let gcount;
        let vlist = [];
        if (vehicles?.length > 0) {
          if (!this.ispassday()) {
            vcount = 0;
            gcount = 0;
            for (let vehicle of vehicles) {
              let {
                vehicle_number,
                vehicle_gnumber,
                vehicle_type,
                state_desc,
                state_time,
                address,
                locationTime,
                driver,
                area,
              } = vehicle;
              if (
                items.some(n => n.vehicle_number && n.vehicle_number === vehicle_number)
                || items.some(n => n.vehicle_gnumber && n.vehicle_gnumber === vehicle_gnumber)
              ) continue;
              vlist.push({
                _type: 'vehicle',
                vehicle_number,
                vehicle_gnumber,
                vehicle_type,
                vehiclestate: state_desc,
                vehiclestatetime: state_time,
                address,
                locationTime,
                driver,
                area,
              });
              if (vehicle_number) vcount++;
              if (vehicle_gnumber) gcount++;
            }
          }
        }
        result.push(
          {
            _type: 'header',
            header,
            vcount,
            gcount,
          },
          ...vlist,
        );
        items.forEach(n => {
          n.sindex = n.index || 999999;
        });
        items.sort((a, b) => {
          if (a.destination !== b.destination) {
            return a.destination.localeCompare(b.destination);
          }
          return a.sindex - b.sindex;
        });
        let index = 0;
        for (let item of items) {
          index++;
          if (item.index !== index) {
            item.index = index;
            update_index = true;
          }
          result.push({
            _type: 'item',
            ...item,
          });
        }
      }
      this.list = result;
      if (update_index) {
        this.bulkupdate('index', result.filter(n => n._type === 'item').map(n => ({ _id: n._id, index: n.index })));
      }
      // console.log(result.filter(n => n._type === 'item').map(n => ({ _id: n._id, index: n.index })));
    },
    bulkupdate(key, list) {
      this.$api.doAPI("/dispatchplan/v2/bulkupdate", { key, list }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata({ hideloading: true });
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showdownloadtask() {
      this.$refs.downloadtaskRef.reset();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-fixed-left>.ant-table-body-outer>.ant-table-body-inner>table>.ant-table-tbody>tr>td {
  padding: 0;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-scroll>.ant-table-body>table>.ant-table-tbody>tr>td {
  padding: 0;
}

/deep/ .highlight {
  background-color: #FFEB9C;
  color: red;
}

/deep/ .vehicle {
  background-color: rgba(255, 0, 0, 0.1);
}

/deep/ .new_created {
  background-color: #FFC7CE;
}

/deep/ .line0 {
  background-color: #DDEBF7;
}

/deep/ .line1 {
  background-color: #BDD7EE;
}

/deep/ .line2 {
  background-color: #9DC3E6;
}

/deep/ .line3 {
  background-color: #E2EFDA;
}

/deep/ .line4 {
  background-color: #C6E0B4;
}

/deep/ .line5 {
  background-color: #FFF2CC;
}

/deep/ .line6 {
  background-color: #FFE699;
}

/deep/ .line7 {
  background-color: #FCE4D6;
}

/deep/ .line8 {
  background-color: #FCE4EC;
}

/deep/ .line9 {
  background-color: #E8DAEF;
}

p {
  margin: 0;
}
</style>